// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"93fae997","255":"4bb35e70","360":"5a5b56bb"}[chunkId] + ".chunk.js";
};